import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../Utils/ReactSelectComponents';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import ReservationAPI from '../../../API/ReservationAPI';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import { FONT_FAMILY_TYPOGRAPHY } from '../../../Utils/Constants';

const lightOrangepalette = createMuiTheme({
  palette: {
    primary: {
      light: '#f5c17b',
      main: '#ED8800',
      dark: '#a55f00',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});

const modalStyles = theme => ({
  paper: {
    position: 'absolute',
    width: '50%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: '#004A5D'
  },
  toolbarRootOnHold: {
    padding: 0,
    backgroundColor: '#ED8800'
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px',
    marginTop: '45px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={2}
      fixedDecimalScale
      decimalScale={0}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};


export class ReservationsCreationModal extends Component {
  dataAPI;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      carQtty: '',
      reservationQtty: '',
      reservationCustomer: '',
      reservationSalesChannel: [],
      openError: false,
      alertMessage: ''
    };
    this.dataAPI = new ReservationAPI();
  }

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleClose = () => {
    this.props.handleClose();
    this.setState({
      loading: false,
      success: false,
      reservationQtty: '',
      reservationCustomer: '',
      reservationSalesChannel: ''
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCreateReservation = () => {
    this.setState({ loading: true });
    let reservationDTO = this.parseStateForSubmit(this.props.carGroupDetails.carsFeaturesHash, this.state);
    this.dataAPI.createReservation(reservationDTO).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.handleClose();
        this.props.reloadTable();
        this.props.detectReservation();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
      this.props.reloadTable();
    });
  };

  parseStateForSubmit(hashCode, state) {
    return {
      reservationHashCode: hashCode,
      reservationQtty: state.reservationQtty,
      reservationCustomer: state.reservationCustomer,
      reservationSalesChannelId: state.reservationSalesChannel.value
    };
  };


  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });
    const carsAvailable = this.props.carGroupDetails.carsAvailableQuantity !== 0;
    let l4SalesChannel = [];

    if (this.props.carGroupDetails.carsSalesChannel !== null && this.props.carGroupDetails.carsSalesChannel !== undefined) {
      l4SalesChannel = this.props.saleChannelData.filter(o1 => this.props.carGroupDetails.carsSalesChannel.some(o2 => o1.value === o2.value));
    }

    return (
      <React.Fragment>

        <MuiThemeProvider key={'0'} theme={carsAvailable ? null : lightOrangepalette}>
          <Modal open={this.props.openModal} onClose={this.handleClose} disableAutoFocus={true}>
            <div style={getModalPosition()} className={classes.paper}>

              <Paper>
                <Toolbar className={carsAvailable ? classes.toolbarRoot : classes.toolbarRootOnHold} >
                  <Typography variant='title' className={classes.titleHead}>
                    REGISTAR RESERVA {carsAvailable ? null : 'EM LISTA DE ESPERA'}
                  </Typography>
                </Toolbar>
              </Paper>

              <form className={classes.formRoot}>
                <Grid container spacing={8}>
                  {carsAvailable ?
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id='carAvailableQtty'
                        label='QUANTIDADE DISPONÍVEL'
                        fullWidth
                        InputProps={{ readOnly: true }}
                        value={this.props.carGroupDetails.carsAvailableQuantity}
                      />
                    </Grid>
                    : null
                  }
                  <Grid item xs={12} sm={carsAvailable ? 6 : 12}>
                    <TextField
                      id='reservationQtty'
                      label='QUANTIDADE A RESERVAR'
                      fullWidth
                      InputProps={{ inputComponent: InputNumber }}
                      value={this.state.reservationQtty}
                      onChange={this.handleChange('reservationQtty')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      id='reservationCustomer'
                      label='CLIENTE'
                      fullWidth
                      inputProps={{ maxLength: 500 }}
                      value={this.state.reservationCustomer}
                      onChange={this.handleChange('reservationCustomer')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.width100}>
                      <InputLabel htmlFor='reservationSalesChannel'>CANAL DE VENDA</InputLabel>
                      <ReactSelect
                        classes={classes}
                        options={l4SalesChannel}
                        components={components}
                        value={this.state.reservationSalesChannel}
                        onChange={this.handleChangeSelect('reservationSalesChannel')}
                        placeholder=''
                      />
                    </div>
                  </Grid>
                </Grid>
                <Toolbar className={classes.footer}>
                  <div className={classes.iconRight}>
                    <Tooltip title='Cancelar' placement='bottom' >
                      <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose.bind(this)}>
                        <CloseIcon />
                      </Button>
                    </Tooltip>
                    <Tooltip title='Guardar' placement='bottom' >
                      <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={() => this.handleCreateReservation()}>
                        {success ? <CheckIcon /> : <SaveIcon />}
                      </Button>
                    </Tooltip>
                    {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                  </div>
                </Toolbar>
              </form>

            </div>
          </Modal>
        </MuiThemeProvider>

        <SnackbarAlert key={'1'} openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </React.Fragment>
    );
  }
}

ReservationsCreationModal.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTable: PropTypes.func,
  handleClose: PropTypes.func,
  detectReservation: PropTypes.func
};

export default withStyles(modalStyles)(ReservationsCreationModal);


// WEBPACK FOOTER //
// ./src/components/Reservations/AvailableCars/ReservationsCreationModal.js